import React from 'react';
import { ISVGType } from './SVGType';

const SuccessRoundIcon = (props: ISVGType) => {
  const { width = 18, height = 18, color = "#3BD378" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <circle cx="9" cy="9" r="9" fill={color} />
      <path d="M5.42861 9.58887L7.42821 11.5893L12.4292 6.59025" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default SuccessRoundIcon;
